var paragraph_default = {
  "fontElementMap": "C7rLL",
  "elementSpacing": "vaqC7",
  "text": "XkByg vaqC7",
  "child": "MMRe0"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
